import "./ColDesignTool.0.css";

/* eslint-disable no-param-reassign */

import { designToolMixin } from "../../../../lib/helpers";
import { startMouseMove } from "../../../../lib/utils";
import { getCompPathParentInfo } from "../../../../lib/utils/layout";
import FloatPortal from '../../../comps/Portal/FloatPortal';
import { safePxAdd } from "../../../../lib/utils/styling";
import { throttle } from "lodash-es";
const __script_base__ = {
  name: 'ColDesignTool',
  components: {
    FloatPortal
  },
  mixins: [designToolMixin],
  data() {
    return {
      dragging: false,
      widthDisplay: ''
    };
  },
  methods: {
    syncSize() {
      const actualEl = this.getCompInstance().$el;
      const {
        width: visualWidth,
        height: visualHeight
      } = actualEl.getBoundingClientRect();
      this.totalWidth = actualEl.offsetWidth;
      this.visualWidth = visualWidth;
      this.visualHeight = visualHeight;
    },
    startResizingWidth(event) {
      const {
        target
      } = event;
      const startWidth = this.width;
      const resizeFactor = this.totalWidth / this.visualWidth;
      event.preventDefault();
      this.dragging = true;
      const lastFactor = this.isLastCol ? -1 : 1;
      const setWidth = async deltaX => {
        await this.modifyComp(e => {
          this.$set(e, 'props', {
            ...e.props,
            width: safePxAdd(lastFactor * deltaX * resizeFactor, startWidth, 'px')
          });
        });
      };
      const setWidthDebounce = throttle(setWidth, 33);
      startMouseMove({
        initialEvent: event,
        onMove: v => {
          this.widthDisplay = safePxAdd(lastFactor * v.deltaX * resizeFactor, startWidth, 'px');
          // target.style.transform = `translateX(${v.deltaX}px)`;
          setWidthDebounce(v.deltaX);
        },
        onEnd: async ({
          deltaX
        }) => {
          this.dragging = false;
          // target.style.transform = '';
          if (Math.abs(deltaX) < 5) {
            await setWidth(0);
            return;
          }
          await setWidth(deltaX);
          await this.$nextTick();
          this.$forceUpdate();
          this.notifyPageletsChange(0);
        }
      });
    },
    startResizing(event) {
      if (this.width) {
        this.startResizingWidth(event);
      }
    }
  },
  computed: {
    canResize() {
      var _this$comp$props;
      return !!((_this$comp$props = this.comp.props) !== null && _this$comp$props !== void 0 && _this$comp$props.width);
    },
    width() {
      var _this$comp$props2;
      return (_this$comp$props2 = this.comp.props) === null || _this$comp$props2 === void 0 ? void 0 : _this$comp$props2.width;
    },
    addButtonTop() {
      return Math.max(0, this.visualHeight / 2 - 18);
    },
    isLastCol() {
      var _getCompPathParentInf;
      // 从父组件row里找到最末的compPath
      const parentCompPath = (_getCompPathParentInf = getCompPathParentInfo(this.compPath)) === null || _getCompPathParentInf === void 0 ? void 0 : _getCompPathParentInf.parentCompPath;
      const parentComp = parentCompPath && this.designer.getCompAtPath(parentCompPath);
      const childrenLength = parentComp.children.length;
      const isLast = this.compPath.endsWith(`${childrenLength - 1}`);
      return isLast;
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "uc-colDesignTool",
    attrs: {
      "data-unused": _vm.syncSize()
    }
  }, [_vm.canResize ? _c('div', {
    style: "\n    z-index:9999;\n      position: absolute;\n      top:" + _vm.addButtonTop + "px;\n      " + (_vm.isLastCol ? 'left' : 'right') + ":0;\n  "
  }, [_c('FloatPortal', [_c('div', {
    staticClass: "uc-colResizer",
    class: {
      isHovering: _vm.isHovering
    },
    staticStyle: {
      "transform": "translate(-6px, 12px)"
    }
  }, [_c('div', {
    staticClass: "ucd-absPosTool-resize",
    on: {
      "mousedown": function ($event) {
        return _vm.startResizing($event);
      },
      "touchstart": function ($event) {
        return _vm.startResizing($event);
      }
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _vm.dragging ? _c('div', {
    style: "\n    z-index:9999;\n      position: absolute;\n      top:" + _vm.addButtonTop + "px;\n      right:50%;\n  "
  }, [_c('div', {
    staticClass: "ucd-absPosTool-tempValueDisplay"
  }, [_c('div', {
    staticClass: "ucd-absPosTool-tempValueDisplay-sizeDiv"
  }, [_vm._v("\n        " + _vm._s(_vm.widthDisplay) + "\n      ")])])]) : _vm._e()]);
};
var staticRenderFns = [];
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "builtin/components/Col/ColDesignTool.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);